module.exports = __webpack_public_path__ + "static/media/euro_accept_info.6b63b492.pdf";